interface IRoutePath {
  relativePath: string
  absolutePath: string
}

interface IRoutes {
  Home: IRoutePath
  Dashboard: IRoutePath
  Vehicles: IRoutePath
  Projects: IRoutePath
  NewProject: IRoutePath
  EditProject: IRoutePath
  NewSubmission: IRoutePath
  EditSubmission: IRoutePath
  Login: IRoutePath
  Profile: IRoutePath
  DataOverview: IRoutePath
  Register: IRoutePath
  MethodologySets: IRoutePath
  AttitudeSets: IRoutePath
  TyreSets: IRoutePath
  DomainSets: IRoutePath
  SimulationSets: IRoutePath
  ProjectConfigs: IRoutePath
  CFDSequences: IRoutePath
  Workflows: IRoutePath
  WorkflowTemplates: IRoutePath
  VehicleStates: IRoutePath
  Submission: IRoutePath
  SubmissionCase: IRoutePath
  Submissions: IRoutePath
  Geometries: IRoutePath
  Sequences: IRoutePath
  RescaleQueue: IRoutePath
  ExternalCase: IRoutePath
  Users: IRoutePath
  SystemMessages: IRoutePath
  NotFound: IRoutePath
  MAVAero: IRoutePath
  MAVAeroDocs: IRoutePath
  MAVAeroWebLauncher: IRoutePath
  PlatformDocs: IRoutePath
  PressureTapImport: IRoutePath
  SolveCountCompliance: IRoutePath
  AdminTaskManagement: IRoutePath
  StorageTest: IRoutePath
}

const routes: IRoutes = {
  Home: { relativePath: '/', absolutePath: '/' },
  Dashboard: { relativePath: 'dashboard', absolutePath: '/dashboard' },
  Projects: { relativePath: 'projects', absolutePath: '/projects' },
  DataOverview: { relativePath: 'data-overview', absolutePath: '/data-overview' },
  MethodologySets: { relativePath: 'methodologies', absolutePath: '/methodologies' },
  TyreSets: { relativePath: 'tyre-sets', absolutePath: '/tyre-sets' },
  DomainSets: { relativePath: 'domain-sets', absolutePath: '/domain-sets' },
  AttitudeSets: { relativePath: 'attitude-sets', absolutePath: '/attitude-sets' },
  SimulationSets: { relativePath: 'simulation-sets', absolutePath: '/simulation-sets' },
  ProjectConfigs: { relativePath: 'project-configs', absolutePath: '/project-configs' },
  Workflows: { relativePath: 'workflows', absolutePath: '/workflows' },
  VehicleStates: { relativePath: 'vehicle-states', absolutePath: '/vehicle-states' },
  Vehicles: { relativePath: 'vehicles', absolutePath: '/vehicles' },
  Geometries: { relativePath: 'geometries', absolutePath: '/geometries' },
  Sequences: { relativePath: 'sequences', absolutePath: '/sequences' },
  CFDSequences: { relativePath: 'cfd-sequences', absolutePath: '/cfd-sequences' },
  Login: { relativePath: 'login', absolutePath: '/auth/login' },
  Register: { relativePath: 'register', absolutePath: '/auth/register' },
  Profile: { relativePath: 'profile', absolutePath: '/profile' },
  NewProject: { relativePath: 'new-project', absolutePath: '/new-project' },
  EditProject: { relativePath: 'projects/:id', absolutePath: '/projects/:id' },
  NewSubmission: { relativePath: 'new-submission', absolutePath: '/new-submission' },
  EditSubmission: { relativePath: 'edit-submission/:id', absolutePath: '/edit-submission/:id' },
  Submissions: { relativePath: 'submissions', absolutePath: '/submissions' },
  Submission: { relativePath: 'submissions/:id', absolutePath: '/submissions/:id' },
  SubmissionCase: { relativePath: 'cases/:id', absolutePath: '/cases/:id' },
  WorkflowTemplates: { relativePath: 'workflow-templates', absolutePath: '/workflow-templates' },
  RescaleQueue: { relativePath: 'rescale-queue', absolutePath: '/rescale-queue' },
  ExternalCase: { relativePath: 'external-case', absolutePath: '/external-case' },
  Users: { relativePath: 'users', absolutePath: '/users' },
  SystemMessages: { relativePath: 'system-messages', absolutePath: '/system-messages' },
  NotFound: { relativePath: 'not-found', absolutePath: '/not-found' },
  MAVAero: { relativePath: 'mav-aero', absolutePath: '/mav-aero' },
  MAVAeroDocs: { relativePath: 'mav-aero-docs', absolutePath: '/mav-aero-docs' },
  MAVAeroWebLauncher: {
    relativePath: 'mav-aero-web-launcher',
    absolutePath: '/mav-aero-web-launcher'
  },
  PlatformDocs: { relativePath: 'platform-docs', absolutePath: '/platform-docs' },
  PressureTapImport: { relativePath: 'pressure-tap-import', absolutePath: '/pressure-tap-import' },
  SolveCountCompliance: {
    relativePath: 'solve-count-compliance',
    absolutePath: '/solve-count-compliance'
  },
  AdminTaskManagement: {
    relativePath: 'admin-task-management',
    absolutePath: '/admin-task-management'
  },
  StorageTest: { relativePath: 'storage-test', absolutePath: '/storage-test' }
}

export default routes
